import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToHashElement = ({ isLoading }) => {
  const location = useLocation();
  const isRendered = useRef(false);
  useEffect(() => {
    if (isRendered.current) return;
    const { hash } = location;
    const removeHashCharacter = (str) => {
      const result = str.slice(1);
      return result;
    };

    if (hash && !isLoading) {
      const element = document.getElementById(removeHashCharacter(hash));

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "nearest",
          block: "center",
        });
        isRendered.current = true;
      }
    }
  }, [location, isLoading]);

  return null;
};

